/**
 * GoKwik Checkout Bridge
 * Reads ?items=VARIANT_ID:QTY,VARIANT_ID:QTY (+ optional &discount=CODE),
 * rebuilds the Shopify cart, then auto-opens the GoKwik checkout.
 * Falls back to native /checkout if the GoKwik SDK never becomes ready.
 */
(function () {
  'use strict';

  var titleEl = document.getElementById('gkb-title');
  var subEl = document.getElementById('gkb-sub');
  var spinnerEl = document.getElementById('gkb-spinner');
  var retryBtn = document.getElementById('gkb-retry');

  function setStatus(title, sub) {
    if (title) titleEl.textContent = title;
    if (sub) subEl.textContent = sub;
  }

  function showError(message) {
    spinnerEl.style.display = 'none';
    setStatus('Something went wrong', message);
    retryBtn.hidden = false;
  }

  function parseItems() {
    var raw = new URLSearchParams(window.location.search).get('items');
    if (!raw) return [];
    return raw
      .split(',')
      .map(function (pair) {
        var parts = pair.split(':');
        return { id: parseInt(parts[0], 10), quantity: parseInt(parts[1], 10) || 1 };
      })
      .filter(function (item) {
        return item.id > 0 && item.quantity > 0;
      });
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    });
  }

  // The SDK (loaded globally by snippets/gokwik.liquid) reads the `cart`
  // global that Liquid rendered at page load — refresh it after mutating.
  function refreshCartGlobal() {
    return fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        window.cart = cart;
        return cart;
      });
  }

  function applyDiscount() {
    var code = new URLSearchParams(window.location.search).get('discount');
    if (!code) return Promise.resolve();
    // Hitting the discount URL sets Shopify's discount cookie for this session.
    return fetch('/discount/' + encodeURIComponent(code)).catch(function () {});
  }

  function sdkReady() {
    return !!(window.Gokwik || window.gokwikSdk || typeof window.onCheckoutClick === 'function');
  }

  function waitForGoKwik(timeoutMs) {
    return new Promise(function (resolve) {
      if (sdkReady()) return resolve(true);
      var settled = false;
      function settle(ok) {
        if (settled) return;
        settled = true;
        clearInterval(poll);
        clearTimeout(timer);
        resolve(ok);
      }
      window.addEventListener('gokwikLoaded', function () { settle(true); });
      var poll = setInterval(function () {
        if (sdkReady()) settle(true);
      }, 250);
      var timer = setTimeout(function () { settle(false); }, timeoutMs);
    });
  }

  // The section renders the store's real GoKwik button off-screen.
  // Clicking it is the same trigger used on product/cart pages.
  function openGoKwik() {
    var btn =
      document.querySelector('#gkb-gokwik-slot .gokwik-checkout button') ||
      document.querySelector('.gokwik-checkout button') ||
      document.querySelector('#gokwik-buy-now');
    if (btn) {
      btn.removeAttribute('disabled');
      btn.classList.remove('disabled');
      try {
        btn.click();
        return true;
      } catch (e) { console.error(e); }
    }
    try {
      if (typeof window.onCheckoutClick === 'function') {
        window.onCheckoutClick(btn);
        return true;
      }
    } catch (e) { console.error(e); }
    try {
      if (window.Gokwik && typeof window.Gokwik.checkout === 'function') {
        window.Gokwik.checkout();
        return true;
      }
    } catch (e) { console.error(e); }
    try {
      if (window.Gokwik && typeof window.Gokwik.openCheckout === 'function') {
        window.Gokwik.openCheckout();
        return true;
      }
    } catch (e) { console.error(e); }
    return false;
  }

  function refreshCartUIAndGlobal() {
    return refreshCartGlobal().then(function (cart) {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
      return cart;
    });
  }

  function run() {
    var items = parseItems();
    if (!items.length) {
      showError('This checkout link is missing products. Please go back and try again.');
      retryBtn.hidden = true;
      return;
    }

    retryBtn.hidden = true;
    spinnerEl.style.display = '';
    setStatus('Preparing your order…', 'Adding your products…');

    applyDiscount()
      .then(function () { return postJSON('/cart/clear.js'); })
      .then(function () { return postJSON('/cart/add.js', { items: items }); })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) {
            throw new Error(err.description || err.message || 'Could not add products');
          });
        }
        return refreshCartUIAndGlobal();
      })
      .then(function () {
        setStatus('Almost there…', 'Opening secure checkout…');
        return waitForGoKwik(15000);
      })
      .then(function (ready) {
        if (ready && openGoKwik()) {
          // Safety hatch: if the modal didn't actually appear, offer a way out.
          setTimeout(function () {
            setStatus('Checkout didn’t open?', 'Tap below to continue — your order and discount are saved.');
            retryBtn.textContent = 'Continue to checkout';
            retryBtn.onclick = function () { window.location.href = '/checkout'; };
            retryBtn.hidden = false;
          }, 8000);
          return;
        }
        // GoKwik unavailable — the cart is correct, so native checkout still works.
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        console.error('[gokwik-bridge]', err);
        showError(err.message || 'Please tap the button below to continue.');
      });
  }

  retryBtn.addEventListener('click', run);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();